module.exports = __webpack_public_path__ + "media/paliwa/u_95@3x-71ea5eac.svg";